import { TagInput } from '@common/components/TagInput';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { TagsInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

interface BrickProps<TFormValues extends FieldValues> {
    config: TagsInputConfig<TFormValues>;
}

export const TagsField = <TFormValues extends FieldValues>({
    config,
}: BrickProps<TFormValues>) => {
    const { control } = useFormContext<TFormValues>();

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <TagInput
                        tags={field.value || []}
                        onChange={field.onChange}
                        options={config.options}
                    />
                )}
            />
        </FieldWrapper>
    );
};
